export default "__VITE_ASSET__uS9vpk8Y__"